export const GAME_TITLE = process.env.REACT_APP_GAME_NAME!

export const WIN_MESSAGES = [
  'You beat Durham! Congratulations!',
  'Mark would be proud!',
  '3/3 marks from the judges!',
  'Gary really enjoyed that!',
  'SEAWEED!',
  'And recalled to the next round: you!',
]
export const GAME_COPIED_MESSAGE = 'Game copied to clipboard'
export const HIGH_CONTRAST_MODE_DESCRIPTION = 'For improved color vision'
export const DISCOURAGE_INAPP_BROWSER_TEXT =
  "You are using an embedded browser and may experience problems sharing or saving your results. Try using your device's default browser instead."
